/* src/app/carousel/carousel.component.scss */
ul {
  list-style: none;
  margin: 0;
  padding: 0;
  height: 6000px;
}
.carousel-wrapper {
  overflow: hidden;
}
.carousel-inner {
  display: flex;
  flex-direction: column;
}
.carousel-item {
  padding: 0px;
  width: 100%;
  border-radius: 30px;
  color: #fff;
  font-size: 50px;
  text-align: center;
  display: block;
}
.carousel-button {
  position: absolute;
  left: 550px;
  bottom: -35px;
  z-index: 0;
  width: 80px;
  height: 40px;
  border-bottom-left-radius: 40px;
  border-bottom-right-radius: 40px;
  background-color: #3D3F47;
  background-image: url(/assets/img/whiteArrow.png);
  background-repeat: no-repeat;
  background-position: 50% 50%;
  border: 0px;
}
.carousel-button.prev-button {
  top: -35px;
  transform: rotate(180deg);
}
.carousel-button:hover {
  background-image: url(/assets/img/greenArrow.png);
}
/*# sourceMappingURL=carousel.component.css.map */
